import { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import getDeviceInfo from 'src/utils/device/info';
const BottomTint = styled.div<{
  $visible: boolean;
}>`
  position: fixed;
  bottom: -8px;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 12px;
  pointer-events: none;
  z-index: 0;
  display: none;
  background-color: #141413;

  ${({
  theme
}) => theme.screenSize.mobile} {
    display: ${({
  $visible
}) => $visible ? 'block' : 'none'};
  }
`;

/**
 * iOS Safari 여부를 감지합니다.
 * iOS Chrome/Firefox 등 다른 브라우저는 제외합니다.
 */
const getIsIOSSafari = (): boolean => {
  if (typeof window === 'undefined') return false;
  const deviceInfo = getDeviceInfo();
  const isIOS = deviceInfo.os?.toLowerCase() === 'ios';
  const isSafari = deviceInfo.browserName?.toLowerCase() === 'safari';
  return isIOS && isSafari;
};

/**
 * iOS 26+ Safari Liquid Glass 툴바 대응 컴포넌트
 *
 * [WEB-4716] Safari 26의 반투명 주소창으로 인해 첫 번째 섹션 아래 콘텐츠(SEO 영역 등)가
 * 주소창을 통해 비쳐 보이는 문제 대응.
 *
 * 화면 하단에 틴트 오버레이를 배치하여 Safari 툴바가 해당 색상을 감지하도록 함.
 * iOS Chrome 등 다른 브라우저에서는 렌더링하지 않습니다.
 *
 * @see https://grooovinger.com/notes/2026-02-27-safari-26-header-background
 * @see https://benfrain.com/ios26-safari-theme-color-tab-tinting-with-fixed-position-elements/
 * @see https://jahir.dev/blog/safari-toolbar
 */
const SafariToolbarTint = () => {
  const [isIOSSafari, setIsIOSSafari] = useState(false);
  useEffect(() => {
    setIsIOSSafari(getIsIOSSafari());
  }, []);
  return <BottomTint $visible={isIOSSafari} aria-hidden='true' data-sentry-element="BottomTint" data-sentry-component="SafariToolbarTint" data-sentry-source-file="index.tsx" />;
};
export default SafariToolbarTint;